<!--
 * @Title: 标题
 * @Description: 描述
 * @Author: xulongyong
 * @Date: 2023-09-10 10:57:51
 * @LastEditors: xulongyong
 * @LastEditTime: 2023-09-10 10:58:02
 * @FilePath: \vue-privilege-routing\src\pages\conduct-main\people-manage\index.vue
-->
<template>
    <div>
       人员管理
    </div>
</template>

<script>
export default {
    data() {
        return {}
    }
}
</script>
